import { render, staticRenderFns } from "./ButtonModalOpen.vue?vue&type=template&id=510ff053"
import script from "./ButtonModalOpen.vue?vue&type=script&lang=js"
export * from "./ButtonModalOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports